import Divider from '@mui/material/Divider';

import { IDividerBlock } from 'src/interfaces/PageBlock';

interface Props {
  block: IDividerBlock;
}

export default function DividerBlockContent({ block: _block }: Props) {
  return <Divider sx={{ width: '100%' }} />;
}
